const CARD_ROWS = [
	".solufy-partner-grid", ".solufy-video-features-grid", ".solufy-pillars-grid",
	".solufy-industries-grid", ".solufy-reviews-grid", ".solufy-reasons-grid",
	".solufy-company-services__grid", ".mission-vision-grid", ".values-cards-grid",
	".solufy-content-grid", ".service-cards-catalog", ".cs-grid:not([data-mobile-card-track])",
	".bm-impact-grid", ".bm-steps-flow",
	".studio-service-catalog:not([data-service-stack])",
].join(",");

export function mountPageAtmosphere(root = document) {
	const glow = root.querySelector(".solufy-ambient");
	if (!glow || glow.dataset.mounted) return;
	glow.dataset.mounted = "true";
	mountCardRows(root);
	const reduced = matchMedia("(prefers-reduced-motion: reduce)");
	let frame;
	const update = () => {
		frame = null;
		const progress = Math.min(1, scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight));
		glow.style.setProperty("--ambient-x", `${Math.sin(progress * Math.PI * 2) * 26}px`);
		glow.style.setProperty("--ambient-y", `${progress * -60}px`);
	};
	const schedule = () => {
		if (!reduced.matches && !frame) frame = requestAnimationFrame(update);
	};
	window.addEventListener("scroll", schedule, { passive: true });
	window.addEventListener("resize", schedule, { passive: true });
	reduced.addEventListener("change", schedule);
	schedule();
}

function mountCardRows(root) {
	root.querySelectorAll(CARD_ROWS).forEach((row) => {
		if (row.children.length < 2) return;
		row.classList.add("solufy-swipe-row");
		row.setAttribute("tabindex", "0");
		row.setAttribute("role", "region");
		const heading = row.closest("section")?.querySelector("h2");
		row.setAttribute("aria-label", `${heading?.textContent.trim() || "Cards"}. Scroll to explore.`);
		mountCardNavigation(row);
	});
}

function mountCardNavigation(row) {
	const navigation = document.createElement("div");
	navigation.className = "solufy-swipe-nav";
	const previous = createCardButton("Previous card", "m14 6-6 6 6 6");
	const next = createCardButton("Next card", "m10 6 6 6-6 6");
	const counter = document.createElement("span");
	counter.setAttribute("aria-live", "polite");
	navigation.append(previous, counter, next);
	row.after(navigation);
	let cards = [];
	let current = 0;
	const update = () => {
		cards = [...row.children].filter((card) => !card.hidden && getComputedStyle(card).display !== "none");
		const left = row.getBoundingClientRect().left;
		current = cards.reduce((closest, card, index) =>
			Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[closest].getBoundingClientRect().left - left) ? index : closest, 0);
		counter.textContent = cards.length ? `${current + 1} / ${cards.length}` : "0 / 0";
		previous.disabled = current === 0;
		next.disabled = current >= cards.length - 1;
	};
	const move = (direction) => {
		const card = cards[current + direction];
		if (!card) return;
		row.scrollBy({
			left: card.getBoundingClientRect().left - row.getBoundingClientRect().left,
			behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
		});
	};
	previous.addEventListener("click", () => move(-1));
	next.addEventListener("click", () => move(1));
	row.addEventListener("scroll", update, { passive: true });
	row.addEventListener("keydown", (event) => {
		if (event.target !== row || !["ArrowLeft", "ArrowRight"].includes(event.key)) return;
		event.preventDefault();
		move(event.key === "ArrowRight" ? 1 : -1);
	});
	new ResizeObserver(update).observe(row);
	new MutationObserver(update).observe(row, { subtree: true, attributes: true, attributeFilter: ["hidden", "style"] });
	update();
}

function createCardButton(label, path) {
	const button = document.createElement("button");
	button.type = "button";
	button.setAttribute("aria-label", label);
	button.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${path}"/></svg>`;
	return button;
}
